import { createFileRoute } from '@tanstack/react-router'

import { AnomaliesPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/anomalies',
)({
  component: () => <AnomaliesPage slug={Route.useParams().slug} />,
})
